export const APP_NAME = 'roleAssumption';
export const ROLE_ASSUMPTION_ROOT_ROUTE = '/role-assumption';
export const INVALID_USER_NAME_MESSAGE = 'Invalid user name. Please try with a valid user.';
export const NO_DEALERSHIP_ASSOCIATED_MESSAGE = 'No dealership is associated with this user. Please contact support.';
